module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/assets/images/favicon.svg","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"83cd35f0836deb78fa333f090de11690"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
